import React from 'react';

import { CiButton } from '@shared/components/CiButton';

const CiAuthNavigatorPage: React.FC = () => {
  return <CiButton redirectUrl="/" />;
};

export { CiAuthNavigatorPage };
